<!-- Loading State -->
@if (isLoading) {
  <div class="global-loading">
    <div class="loading-spinner"></div>
  </div>
}

<!-- Error State -->
@if (errorMessage && !isLoading) {
  <div class="error-container">
    <p class="error-message">{{ errorMessage }}</p>

    @if (errorMessage.includes('servidor')) {
      <button class="retry-button" (click)="loadLeadDetails()">Tentar novamente</button>
    }
  </div>
}

@if (!isLoading && !errorMessage) {
  @switch (getLayoutType()) {
    @case ('PA') {
      <app-lead-details-pa
        [details]="leadDetails"
        (navigate)="navigateToPage($event)"
        (generateSimulation)="gerarNovaSimulacao()"
      />
    }
    @case ('PR') {
      <app-lead-details-pr
        [details]="leadDetails"
        [showQuickApproval]="exibirReguaQuickApproval"
        [sliderLoading]="sliderLoading"
        [sliderValue]="sliderValue"
        [reguaSegments]="reguaSegments"
        (sliderValueChange)="onSliderValueChange($event)"
        (navigate)="navigateToPage($event)"
        (generateSimulation)="gerarNovaSimulacao()"
      />
    }
    @case ('SS') {
      <app-lead-details-ss
        [details]="leadDetails"
      />
    }
    @case ('SP') {
      <app-lead-details-sp
        [details]="leadDetails"
      />
    }
    @case ('CC') {
      <app-leads-details-cc
        [details]="leadDetails"
      />
    }
    @default {
      <app-lead-details-so
        [details]="leadDetails"
        [showQuickApproval]="exibirReguaQuickApproval"
        [sliderLoading]="sliderLoading"
        [sliderValue]="sliderValue"
        [reguaSegments]="reguaSegments"
        (sliderValueChange)="onSliderValueChange($event)"
        (navigate)="navigateToPage($event)"
        (generateSimulation)="gerarNovaSimulacao()"
      />
    }
  }
}
